import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";
import {
  buildHaircolorUserPhotoContinueUrl,
  getHaircolorV2ContinueUrl,
} from "./haircolorUserPhotoContinue";

const HAIRCOLOR_PROGRESS_STEPS = [
  { threshold: 10, label: "Analyzing undertone and skin warmth" },
  { threshold: 35, label: "Measuring contrast and depth levels" },
  { threshold: 60, label: "Checking harmony with natural hair depth" },
  { threshold: 85, label: "Comparing flattering shade directions" },
  { threshold: 100, label: "Selecting your best haircolor range" },
];

export { getHaircolorV2ContinueUrl } from "./haircolorUserPhotoContinue";

const FaceMeshHaircolorV2Page = () => {
  const continueUrl = getHaircolorV2ContinueUrl(window.location.search);

  return (
    <FaceMeshAsyncV2Page
      analyticsPrefix="facemesh_haircolor_v2"
      buildContinueUrlOverride={buildHaircolorUserPhotoContinueUrl}
      continueUrl={continueUrl}
      missingImageHelpPath="/facemesh-haircolor-v2"
      pagePath="/facemesh-haircolor-v2"
      progressSteps={HAIRCOLOR_PROGRESS_STEPS}
    />
  );
};

export default FaceMeshHaircolorV2Page;
